import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import useFetch from '../../../hooks/useFetch';
import { fetchUserGames } from '../../../api/games';

const getGameType = game => {
    if (game.TournamentEntry?.Tournament?.name) return 'T';
    if (game.userCampaignContestID) return 'C';
    return null;
};

const GAME_TYPE_LABELS = { T: 'Tournament', C: 'Campaign' };

const RecentGamesCard = ({ userID }) => {
    const { data: rawGames, loading } = useFetch(fetchUserGames, []);

    const recentGames = useMemo(
        () => (rawGames || []).filter(g => g.isFinal).slice(0, 5),
        [rawGames]
    );

    const getOpponent = useCallback(
        game => {
            const opponent = game.GameParticipants?.find(p => String(p.userID) !== String(userID));
            return opponent?.UserTeam?.name || 'Unknown';
        },
        [userID]
    );

    const getScore = useCallback(game => {
        const match = game.resultDescription?.match(/H:\s*(\d+)\s*-\s*V:\s*(\d+)/);
        if (!match) return '';
        return `${match[1]}-${match[2]}`;
    }, []);

    if (loading || recentGames.length === 0) return null;

    return (
        <div className="priority-card">
            <div className="priority-card-header">
                <h3>Recent Games</h3>
                <Link to="/games/user">View All</Link>
            </div>
            {recentGames.map(game => {
                const isWin = game.resultDescription?.startsWith('Win');
                const gameType = getGameType(game);
                return (
                    <Link key={game.gameID} to={`/game/${game.gameID}/summary`} className="dash-game-row">
                        <span className={`dash-game-result ${isWin ? 'win' : 'loss'}`}>{isWin ? 'W' : 'L'}</span>
                        <span className="dash-game-opponent">vs {getOpponent(game)}</span>
                        {gameType ? (
                            <span
                                className={`dash-game-type dash-game-type-${gameType.toLowerCase()}`}
                                title={GAME_TYPE_LABELS[gameType]}
                            >
                                {gameType}
                            </span>
                        ) : null}
                        <span className="dash-game-score">{getScore(game)}</span>
                        <span className="dash-game-date">{new Date(game.created).toLocaleDateString()}</span>
                    </Link>
                );
            })}
        </div>
    );
};

RecentGamesCard.propTypes = {
    userID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default RecentGamesCard;
